/**
 * The alias to this folder is client/supercharged
 *
 * Consider using this file as entry point to the container.
 * Ideally, you should import, bind and register all req  required modules or components from here
 */

import components from './components'
import routes from './routes'
import * as vuex from './vuexstore'

import AlertMixin from './components/_mixins/alert'
import CartMixin from './components/_mixins/checkout'
import ConfigMixin from './components/_mixins/config'
import DatesMixin from './components/_mixins/dates'
import GiftCardMixin from './components/_mixins/giftcard'
import PagesMixin from './components/_mixins/pages'
import RacesMixin from './components/_mixins/races'
import ResponsiveMixin from './components/_mixins/responsive'
import ScrollerMixin from './components/_mixins/scroller'
import TimerMixin from './components/_mixins/timer'
import ValidationMixin from './components/_mixins/validation'

import Config from './lib/config'
import * as Dates from './lib/dates'
import * as Utils from './lib/utils'
import * as Validations from './lib/validations'

import MainService from './services/main'
import ProviderService from './services/provider'

// injections into the existing website like adding loyalty status in header etc.
// import './injections'

export default {
  vuex,
  routes,
  components,
  lib: {Config, Dates, Utils, Validations},
  services: {MainService, ProviderService},
  mixins: {AlertMixin, CartMixin, ConfigMixin, DatesMixin, GiftCardMixin, PagesMixin, RacesMixin, ResponsiveMixin, ScrollerMixin, TimerMixin, ValidationMixin},
}
